import { View, Card, CardContent, Badge } from "@/components/ui";
import { WorkerAvatar } from "@/components/shared/worker-avatar";
import { Star } from "@/components/shared/icons";
import { Typography } from "../typography";

export const WorkerProfileCard = ({
  name,
  avatar,
  star,
}: {
  name: string;
  avatar: string;
  star: string;
}) => {
  return (
    <View className="px-4">
      <Card className="w-full">
        <CardContent>
          <View className="flex flex-row items-center justify-between">
            <View className="flex flex-row items-center gap-2">
              <WorkerAvatar src={avatar} size={48} />
              <Typography variant="label-sm" align="center">
                {name}
              </Typography>
            </View>
            <Badge variant="warning">
              <View className="flex flex-row items-center gap-1">
                <Star weight="fill" className="text-warning" size={12} />
                <Typography variant="caption-sm" color="warning-on-surface">
                  {Number(star).toFixed(1)}
                </Typography>
              </View>
            </Badge>
          </View>
        </CardContent>
      </Card>
    </View>
  );
};
